import { useRef, useState } from "react"
import { useLocation } from "react-router-dom"

import { SectionHeading, TableCustom, WrapperAdvancedSearch, FooterButtonVolver } from "../../components/common"
import { ServerRequest } from "../../utils/apiweb"
import { OPERATION_MODE, REQUEST_METHOD } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { useManagedContext } from "../../components/hooks"
import { usePermissions } from "../../components/hooks/usePermissions"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import TipoMovimientoModal from "../../components/controls/TipoMovimientoModal"
import { PERMISSIONS } from "../../consts/permissions"
import { useSearchParams } from "react-router-dom"
const TipoMovimientosView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()
    const location = useLocation()
    const previousFilters = location.state?.filters

    const [tableVisible, setTableVisible] = useState()
    const [tipos, setTipos] = useState([])
    const [editMode, setEditMode] = useState()
    const [editItem, setEditItem] = useState()

    const searchRef = useRef()
    
    const { hasPermission } = usePermissions();
    const [search] = useSearchParams();
    const canEdit = hasPermission(PERMISSIONS.TIPO_MOVIMIENTO_EDIT);
    const isViewOnly = search.get('mode') === OPERATION_MODE.VIEW;
    const allowEditActions = canEdit && !isViewOnly;

    const filterData = (data) => {
        const { codigo, nombre, numero, imputacion, tipo } = searchRef.current.filters

        let filtered = [...data]

        if (codigo !== '') filtered = filtered.filter(item => item.codigo.toLowerCase() === codigo.toLowerCase())
        if (nombre !== '') filtered = filtered.filter(item => item.nombre.toLowerCase().includes(nombre.toLowerCase()))
        if (numero !== '') filtered = filtered.filter(item => item.numero.toString() === numero)
        if (imputacion !== 0) filtered = filtered.filter(item => item.imputacion === imputacion)
        if (tipo !== '') filtered = filtered.filter(item => item.tipo.toLowerCase() === tipo.toLowerCase())

        return filtered
    }

    const Search = () => {
        setIsLoading(true)

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_MOVIMIENTO,
            null,
            null,
            res => res.json().then(data => {
                setTipos(filterData(data))
                setIsLoading(false)
                setTableVisible(true)
                setEditMode(null)
                setEditItem(null)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
        )
    }

    const confirmRemoveId = (id) => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.TIPO_MOVIMIENTO,
            `/${id}`,
            null,
            () => {
                Search()
                setIsLoading(false)
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const onModalCancel = () => {
        setEditItem(null)
        setEditMode(null)
    }

    const onModalConfirm = () => {
        setEditItem(null)
        setEditMode(null)
        if (tableVisible) Search()
    }

    const avmr = {
        onAdd: () => {
            setEditMode('add')
            setEditItem({
                id: -Date.now(),
                codigo: '',
                nombre: '',
                orden: '',
                actEmitido: false,
                automatico: false,
                autonumerado: false,
                numero: 0,
                imputacion: 0,
                tipo: '',
            })
        },
        onView: (item) => {
            setEditMode('view')
            setEditItem(item)
        },
        onModify: (item) => {
            setEditMode('modify')
            setEditItem(item)
        },
        onRemove: ({ id }) => {
            showMessageModal({
                title: "Confirmación",
                message: "¿Está seguro de borrar el registro?",
                onConfirm: () => confirmRemoveId(id),
            })
        }
    }

    return <>
        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas', url: '/entidades' }, { title: 'Tipos de movimientos' }]}
                        onAddClick={allowEditActions ? avmr.onAdd : null} {...{tableVisible}} />

        <section className="section-accordion">
            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'Código', field: 'codigo', type: 'string', size: 2, searchOnEnter: true, },
                    { title: 'Nombre', field: 'nombre', type: 'string', size: 4, searchOnEnter: true, },
                    { title: 'Número', field: 'numero', type: 'string', size: 1, searchOnEnter: true, },
                    {
                        title: 'Imputación',
                        field: 'imputacion',
                        type: 'selectLista',
                        size: 2,
                        options: [
                            { value: 0, label: 'Todos', },
                            { value: 'D', label: 'D', },
                            { value: 'H', label: 'H', },
                            { value: 'F', label: 'F', },
                        ],
                        emptyValue: 0,
                    },
                    { title: 'Tipo', field: 'tipo', type: 'string', size: 1, searchOnEnter: true, },
                ]}
                onSearch={Search}
            />

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    data={tipos}
                    avmr={avmr}
                    editCode={PERMISSIONS.TIPO_MOVIMIENTO_EDIT}
                    disabled={!allowEditActions}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        { Header: 'Código', accessor: 'codigo', width: '20%', },
                        { Header: 'Nombre', accessor: 'nombre', width: '40%', },
                        { Header: 'Número', accessor: 'numero', width: '20%', },
                        { Header: 'Imputación', accessor: 'imputacion', width: '10%', },
                        { Header: 'Tipo', accessor: 'tipo', width: '10%', },
                    ]}
                />
            )}

            {editItem && (
                <TipoMovimientoModal
                    {...{editMode, editItem}}
                    onCancel={onModalCancel}
                    onConfirm={onModalConfirm}
                />
            )}
        </section>
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>
    </>
}

export default TipoMovimientosView
